<template>
  <ModalDefault modal_id="upgradeTesterModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="`Quero contratar!`"
                icon="bx bx-rocket mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div class="row px-3 py-3">
        <div class="col-12 d-flex"
             style="justify-content: center; margin-top: -50px; margin-bottom: -90px;">
          <lottie-player src="https://assets10.lottiefiles.com/packages/lf20_zpo7qo16.json"
                         background="transparent"
                         speed="0.9"
                         style="width: 100%; height: 500px;"
                         loop  autoplay>
          </lottie-player>
        </div>
        <div class="col-12 text-center">
          <h5 class="title-color">{{ `Leve seu atendimento ao próximo nível!` }}</h5>
          <span>
             {{ `Indique por quais meios você deseja receber o contato dos nossos especialistas:` }}
          </span>
        </div>
        <div class="col-md-6 col-sm-12 py-2 text-center">
          <div>
            <div style="justify-content: center;"
                 class="cursor_pointer custom-control d-flex custom-switch ellipsis">
              <input type="checkbox"
                     class="cursor_pointer custom-control-input ellipsis"
                     id="switch_email"
                     :disabled="me.data.id !== 1"
                     @change="me.data.role_key > 0 ? switchChange('human') : null"
                     :checked="channels.channel.parameter && channels.channel.parameter.modules && channels.channel.parameter.modules.human">
              <label class="cursor_pointer custom-control-label pl-50 ml-2 mr-2" for="switch_email">
                <span class="ellipsis ml-1" style="font-size: 1.1rem;">{{ me.data.email }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 text-center">
          <div>
            <div style="justify-content: center;"
                 class="cursor_pointer custom-control d-flex custom-switch ellipsis">
              <input type="checkbox"
                     class="cursor_pointer custom-control-input ellipsis"
                     id="switch_whatsapp"
                     :disabled="me.data.id !== 1"
                     @change="me.data.role_key > 0 ? switchChange('human') : null"
                     :checked="channels.channel.parameter && channels.channel.parameter.modules && channels.channel.parameter.modules.human">
              <label class="cursor_pointer custom-control-label pl-50 ml-2 mr-2" for="switch_whatsapp">
                <span class="ellipsis ml-1" style="font-size: 1.1rem;">{{ `5511987878787` }}</span>
              </label>
            </div>
          </div>
        </div>
        <div class="col-12 pt-4 pb-4 text-center">
          <div class="pt-1">
            <div data-toggle="modal"
                 @click.prevent=""
                 class="btn-sm btn btn-primary py-2 px-3 shadow-none rounded-0">
              <i v-if="false" class="bx bxs-rocket pr-2"></i>
              <strong style="font-size: 16px;">{{ `Quero contratar!` }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";

export default {
  name: "ModalUpgradeTester",
  components: {
    ModalDefault,
  },

}
</script>

<style scoped>

</style>
